export const cookieConsentTranslations = {
  en: {
    consentModal: {
      title: "We use cookies!",
      description: `Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. 
      The latter will be set only after consent. <a href="/cookie-policy" class="cc-link">Read more</a>`,
      acceptAllBtn: "Accept all",
      acceptNecessaryBtn: "Reject all",
      showPreferencesBtn: "Manage preferences",
      footer: `
        <a href="/privacy-policy">Privacy Policy</a>
        <a href="/terms-conditions">Terms and Conditions</a>
      `,
    },
    preferencesModal: {
      title: "Manage cookie preferences",
      acceptAllBtn: "Accept all",
      acceptNecessaryBtn: "Reject all",
      savePreferencesBtn: "Accept current selection",
      closeIconLabel: "Close modal",
      sections: [
        {
          title: "Somebody said ... cookies?",
          description:
            "I use cookies to ensure the basic functionalities of the website and to enhance your online experience. " +
            "You can choose for each category to opt-in/out whenever you want. " +
            "For more details relative to cookies and other sensitive data, please read the full" +
            ' <a href="https://dev.connexxtion.ch/privacy-policy" class="cc-link">privacy policy</a>.',
        },
        {
          title: "Strictly Necessary cookies",
          description:
            "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
          linkedCategory: "necessary",
          toggle: {
            value: "necessary",
            enabled: true,
            readonly: true,
            ariaLabel: "Necessary cookies",
          },
        },
        {
          title: "Performance and Analytics cookies",
          description:
            "These cookies allow the website to remember the choices you have made in the past",
          linkedCategory: "analytics",
          toggle: {
            value: "analytics",
            enabled: false,
            readonly: false,
          },
        },
        {
          title: "More information",
          description:
            'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#">contact us</a>.<br/><br/>' +
            'You can also read our full <a class="cc-link" href="https://connexxtion.ch/cookie-policy">Cookie Policy</a> ' +
            "to understand how we manage cookies and other tracking technologies.",
        },
      ],
    },
  },
  ru: {
    consentModal: {
      title: "Мы используем cookies!",
      description: `Привет! Этот сайт использует необходимые файлы cookie для обеспечения правильной работы и отслеживающие файлы cookie, чтобы понять, как вы с ним взаимодействуете. 
      Последние будут установлены только после согласия. <a href="/cookie-policy" class="cc-link">Читать далее</a>`,
      acceptAllBtn: "Принять все",
      acceptNecessaryBtn: "Отклонить все",
      showPreferencesBtn: "Управление настройками",
      footer: `
        <a href="/privacy-policy">Политика конфиденциальности</a>
        <a href="/terms-conditions">Условия использования</a>
      `,
    },
    preferencesModal: {
      title: "Управление настройками cookie",
      acceptAllBtn: "Принять все",
      acceptNecessaryBtn: "Отклонить все",
      savePreferencesBtn: "Принять текущий выбор",
      closeIconLabel: "Закрыть модальное окно",
      sections: [
        {
          title: "Кто-то говорил... cookies?",
          description:
            "Я использую cookie для обеспечения основных функций сайта и улучшения вашего онлайн-опыта. " +
            "Вы можете выбрать для каждой категории включить/выключить в любое время. " +
            "Для получения дополнительной информации о cookie и других конфиденциальных данных, пожалуйста, прочтите полную" +
            ' <a href="https://dev.connexxtion.ch/privacy-policy" class="cc-link">политику конфиденциальности</a>.',
        },
        {
          title: "Строго необходимые cookie",
          description:
            "Эти файлы cookie необходимы для правильной работы моего веб-сайта. Без этих файлов cookie веб-сайт не будет работать должным образом",
          linkedCategory: "necessary",
          toggle: {
            value: "necessary",
            enabled: true,
            readonly: true,
            ariaLabel: "Необходимые cookie",
          },
        },
        {
          title: "Cookie производительности и аналитики",
          description:
            "Эти файлы cookie позволяют веб-сайту запоминать сделанный вами выбор в прошлом",
          linkedCategory: "analytics",
          toggle: {
            value: "analytics",
            enabled: false,
            readonly: false,
          },
        },
        {
          title: "Дополнительная информация",
          description:
            'По любым вопросам, касающимся нашей политики в отношении файлов cookie и вашего выбора, пожалуйста, <a class="cc-link" href="#">свяжитесь с нами</a>.<br/><br/>' +
            'Вы также можете прочитать нашу полную <a class="cc-link" href="https://connexxtion.ch/cookie-policy">Политику использования cookie</a>, ' +
            "чтобы понять, как мы управляем файлами cookie и другими технологиями отслеживания.",
        },
      ],
    },
  },
  de: {
    consentModal: {
      title: "Wir verwenden Cookies!",
      description: `Hallo! Diese Website verwendet wichtige Cookies, um den ordnungsgemäßen Betrieb zu gewährleisten, und Tracking-Cookies, um zu verstehen, wie Sie mit ihr interagieren. 
      Letztere werden nur nach Zustimmung gesetzt. <a href="/cookie-policy" class="cc-link">Mehr lesen</a>`,
      acceptAllBtn: "Alle akzeptieren",
      acceptNecessaryBtn: "Alle ablehnen",
      showPreferencesBtn: "Einstellungen verwalten",
      footer: `
        <a href="/privacy-policy">Datenschutzerklärung</a>
        <a href="/terms-conditions">Nutzungsbedingungen</a>
      `,
    },
    preferencesModal: {
      title: "Cookie-Einstellungen verwalten",
      acceptAllBtn: "Alle akzeptieren",
      acceptNecessaryBtn: "Alle ablehnen",
      savePreferencesBtn: "Aktuelle Auswahl akzeptieren",
      closeIconLabel: "Modal schließen",
      sections: [
        {
          title: "Jemand sagte... Cookies?",
          description:
            "Ich verwende Cookies, um die grundlegenden Funktionen der Website sicherzustellen und Ihre Online-Erfahrung zu verbessern. " +
            "Sie können für jede Kategorie jederzeit ein-/ausschalten. " +
            "Für weitere Details zu Cookies und anderen sensiblen Daten lesen Sie bitte die vollständige" +
            ' <a href="https://dev.connexxtion.ch/privacy-policy" class="cc-link">Datenschutzerklärung</a>.',
        },
        {
          title: "Unbedingt erforderliche Cookies",
          description:
            "Diese Cookies sind für das ordnungsgemäße Funktionieren meiner Website unerlässlich. Ohne diese Cookies würde die Website nicht richtig funktionieren",
          linkedCategory: "necessary",
          toggle: {
            value: "necessary",
            enabled: true,
            readonly: true,
            ariaLabel: "Notwendige Cookies",
          },
        },
        {
          title: "Leistungs- und Analyse-Cookies",
          description:
            "Diese Cookies ermöglichen es der Website, sich an Entscheidungen zu erinnern, die Sie in der Vergangenheit getroffen haben",
          linkedCategory: "analytics",
          toggle: {
            value: "analytics",
            enabled: false,
            readonly: false,
          },
        },
        {
          title: "Weitere Informationen",
          description:
            'Bei Fragen zu unserer Cookie-Richtlinie und Ihren Wahlmöglichkeiten <a class="cc-link" href="#">kontaktieren Sie uns</a>.<br/><br/>' +
            'Sie können auch unsere vollständige <a class="cc-link" href="https://connexxtion.ch/cookie-policy">Cookie-Richtlinie</a> lesen, ' +
            "um zu verstehen, wie wir Cookies und andere Tracking-Technologien verwalten.",
        },
      ],
    },
  },
  fr: {
    consentModal: {
      title: "Nous utilisons des cookies !",
      description: `Salut ! Ce site web utilise des cookies essentiels pour assurer son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. 
      Ces derniers ne seront définis qu'après consentement. <a href="/cookie-policy" class="cc-link">En savoir plus</a>`,
      acceptAllBtn: "Tout accepter",
      acceptNecessaryBtn: "Tout refuser",
      showPreferencesBtn: "Gérer les préférences",
      footer: `
        <a href="/privacy-policy">Politique de confidentialité</a>
        <a href="/terms-conditions">Conditions d'utilisation</a>
      `,
    },
    preferencesModal: {
      title: "Gérer les préférences de cookies",
      acceptAllBtn: "Tout accepter",
      acceptNecessaryBtn: "Tout refuser",
      savePreferencesBtn: "Accepter la sélection actuelle",
      closeIconLabel: "Fermer la modale",
      sections: [
        {
          title: "Quelqu'un a dit... des cookies ?",
          description:
            "J'utilise des cookies pour assurer les fonctionnalités de base du site web et améliorer votre expérience en ligne. " +
            "Vous pouvez choisir pour chaque catégorie d'accepter/refuser quand vous voulez. " +
            "Pour plus de détails sur les cookies et autres données sensibles, veuillez lire la" +
            ' <a href="https://dev.connexxtion.ch/privacy-policy" class="cc-link">politique de confidentialité</a> complète.',
        },
        {
          title: "Cookies strictement nécessaires",
          description:
            "Ces cookies sont essentiels au bon fonctionnement de mon site web. Sans ces cookies, le site web ne fonctionnerait pas correctement",
          linkedCategory: "necessary",
          toggle: {
            value: "necessary",
            enabled: true,
            readonly: true,
            ariaLabel: "Cookies nécessaires",
          },
        },
        {
          title: "Cookies de performance et d'analyse",
          description:
            "Ces cookies permettent au site web de se souvenir des choix que vous avez faits dans le passé",
          linkedCategory: "analytics",
          toggle: {
            value: "analytics",
            enabled: false,
            readonly: false,
          },
        },
        {
          title: "Plus d'informations",
          description:
            'Pour toute question concernant notre politique en matière de cookies et vos choix, veuillez <a class="cc-link" href="#">nous contacter</a>.<br/><br/>' +
            'Vous pouvez également lire notre <a class="cc-link" href="https://connexxtion.ch/cookie-policy">Politique de cookies</a> complète ' +
            "pour comprendre comment nous gérons les cookies et autres technologies de suivi.",
        },
      ],
    },
  },
  it: {
    consentModal: {
      title: "Utilizziamo i cookie!",
      description: `Ciao! Questo sito web utilizza cookie essenziali per garantire il suo corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. 
      Questi ultimi verranno impostati solo dopo il consenso. <a href="/cookie-policy" class="cc-link">Leggi di più</a>`,
      acceptAllBtn: "Accetta tutto",
      acceptNecessaryBtn: "Rifiuta tutto",
      showPreferencesBtn: "Gestisci preferenze",
      footer: `
        <a href="/privacy-policy">Informativa sulla privacy</a>
        <a href="/terms-conditions">Termini e condizioni</a>
      `,
    },
    preferencesModal: {
      title: "Gestisci le preferenze dei cookie",
      acceptAllBtn: "Accetta tutto",
      acceptNecessaryBtn: "Rifiuta tutto",
      savePreferencesBtn: "Accetta selezione corrente",
      closeIconLabel: "Chiudi modale",
      sections: [
        {
          title: "Qualcuno ha detto... cookie?",
          description:
            "Uso i cookie per garantire le funzionalità di base del sito web e migliorare la tua esperienza online. " +
            "Puoi scegliere per ogni categoria di accettare/rifiutare quando vuoi. " +
            "Per maggiori dettagli sui cookie e altri dati sensibili, leggi la" +
            ' <a href="https://dev.connexxtion.ch/privacy-policy" class="cc-link">informativa sulla privacy</a> completa.',
        },
        {
          title: "Cookie strettamente necessari",
          description:
            "Questi cookie sono essenziali per il corretto funzionamento del mio sito web. Senza questi cookie, il sito web non funzionerebbe correttamente",
          linkedCategory: "necessary",
          toggle: {
            value: "necessary",
            enabled: true,
            readonly: true,
            ariaLabel: "Cookie necessari",
          },
        },
        {
          title: "Cookie di prestazioni e analisi",
          description:
            "Questi cookie permettono al sito web di ricordare le scelte che hai fatto in passato",
          linkedCategory: "analytics",
          toggle: {
            value: "analytics",
            enabled: false,
            readonly: false,
          },
        },
        {
          title: "Maggiori informazioni",
          description:
            'Per qualsiasi domanda relativa alla nostra politica sui cookie e alle tue scelte, <a class="cc-link" href="#">contattaci</a>.<br/><br/>' +
            'Puoi anche leggere la nostra <a class="cc-link" href="https://connexxtion.ch/cookie-policy">Politica dei cookie</a> completa ' +
            "per capire come gestiamo i cookie e altre tecnologie di tracciamento.",
        },
      ],
    },
  },
};
